import firebase from "firebase";
import axios from "axios";

//
export function FetchQuizData(classLevel) {
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                let email = user.email;
                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                studentFile.getDownloadURL()
                    .then(async url => await axios.get(url))
                    .then(res => {
                            let studentData = res.data;
                            for (let i = 0; i < studentData.length; i++) {
                                if (studentData[i].email === email) {
                                    resolve(studentData[i].assignmentCompletion)
                                    break;
                                }

                            }
                        }
                    )
            }
        })
    });
}
